module.exports = __webpack_public_path__ + "img/talks_2.48d7b0c4.png";